/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {EmailTranslationListPageComponent} from './email-translation-list-page.component';

@Component({
  standalone: true,
  imports: [EmailTranslationListPageComponent],
  selector: 'adn-email-translation-route-page',
  template: `
    <adn-email-translation-list-page [readOnly]="readOnly"></adn-email-translation-list-page>
  `
})
export class EmailTranslationRoutePageComponent {
  @Input() readOnly = false;
}
